<script setup lang="ts">
import { toRef } from 'vue';

import VButton from '@components/buttons/VButton/VButton.vue';
import VFormSelectInput from '@modules/forms/components/inputs/VFormSelectInput/VFormSelectInput.vue';
import { useReportsMedia } from '@modules/reports/composables';
import VSmartFilterDateRange from '@modules/smart-filters/components/VSmartFilterDate/VSmartFilterDateRange.vue';

import type {
  IDateRangeEmits,
  IDateRangeProps,
} from './types';
import { useDateRangeWithPresets } from './composables';

const props = defineProps<IDateRangeProps>();
const emit = defineEmits<IDateRangeEmits>();

const {
  datePeriodOptions,
  currentPeriod,
  pickerData,
  onPeriodChange,
  onPickerChange,
  onSelectChange,
} = useDateRangeWithPresets(
  toRef(props, 'translationKey'),
  toRef(props, 'defaultPeriodName'),
  emit,
);

const {
  isGreaterThenMd,
  selectLabel,
} = useReportsMedia();
</script>

<template>
  <div v-data-qa-auto-id="'VDateRangeWithPresets'" class="mb-6 md:mb-2">
    <template v-if="isGreaterThenMd">
      <VButton
        v-for="item in datePeriodOptions"
        :key="item.name"
        :label="item.label"
        :outlined="currentPeriod?.name === item.name"
        :text="currentPeriod?.name !== item.name"
        :raised="false"
        class="mb-2 min-w-0 align-middle text-muted-color"
        @click="onPeriodChange(item)"
      />
    </template>
    <template v-else>
      <VFormSelectInput
        :options="datePeriodOptions"
        :value="currentPeriod?.name"
        :label="selectLabel"
        option-label="label"
        option-value="name"
        hide-errors
        @change="onSelectChange"
      />
    </template>
    <div class="mb-2 ml-0 mt-6 block align-middle md:ml-4 md:mt-0 md:inline-block">
      <VSmartFilterDateRange
        :data="pickerData"
        :show-clear="false"
        :max-years-range="1"
        class="w-80 input-max-width max-md:w-full"
        @change="onPickerChange"
      />
    </div>
  </div>
</template>
